var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 18,
    height: 18,
    viewBox: "0 0 114.2 114.2",
    style: {
      enableBackground: "new 0 0 114.2 114.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1,0.7C26,0.7,0.7,26,0.7,57.1c0,31.1,25.3,56.4,56.4,56.4c31.1,0,56.4-25.3,56.4-56.4C113.5,25.9,88.2,0.7,57.1,0.7z  M83.6,63.6c-3.3,16.7-21.5,11.2-23.2,10.7c0.4,1.7,1.8,6.3,4.3,9c3.2,3.4,1.5,5,1.5,5H47.9c0,0-1.6-1.6,1.6-5 c2.6-2.7,3.9-7.4,4.3-9c-1.8,0.6-20,6.2-23.2-10.7C27.2,45.9,49,38,53.1,30.4c3.6-6.7,4-6.5,4-6.5s0.5-0.2,4,6.5 C65.1,38,87.1,46,83.6,63.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.deafb59cde133897335dca6cdbbe6002.svg";
export { ForwardRef as ReactComponent };